export const TAG_BANNED_CHARACTERS = [',', '|', '+'];
